import { Form, Modal, Select } from "antd";
import React from "react";
import { CreateWorkshopDto } from "../../../api";
import { WorkshopColumns } from "../form/columns";
import { useAppSelector } from "../../../app/hooks";
import { selectOrganizationsProfile } from "../../organizationProfile/organizationProfileSlice";

interface WorkshopFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWorkshop: (values: CreateWorkshopDto) => void;
}

export const WorkshopForm: React.FC<WorkshopFormProps> = ({ visible, setVisible, onCreateWorkshop }) => {
  const organization = useAppSelector(selectOrganizationsProfile);

  const [form] = Form.useForm<CreateWorkshopDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateWorkshop}>
        {WorkshopColumns().map(({ title, dataIndex, key, rules, inputNode }) => (
          <Form.Item label={title} name={key} rules={rules}>
            {inputNode}
          </Form.Item>
        ))}
        <Form.Item label="Промышленная площадка" name="industrialSiteId" rules={[{ required: true, message: "Выберите площадку" }]}>
          <Select
            options={organization?.industrialSites?.map((industrialSite) => {
              return {
                value: industrialSite.id,
                label: industrialSite.name,
              };
            })}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
